import React from "react";

const CircleIcon = ({ children, tone = "green" }) => {
  const toneClass =
    tone === "pink"
      ? "bg-pink-50 text-pink-500 dark:bg-pink-950/50 dark:text-pink-300"
      : tone === "amber"
        ? "bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300"
        : "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300";

  return (
    <span
      className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full ${toneClass}`}
      aria-hidden="true"
    >
      {children}
    </span>
  );
};

export default CircleIcon;
